// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/index.scss';

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta)
      .forEach((id) => {
        const node = document.querySelector(`.${id}`);

        if (node) {
          node.innerHTML = meta[id];
        }
      });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}
